export default "__VITE_ASSET__0840cdb1__"